import { render, staticRenderFns } from "./AdviserSettings.vue?vue&type=template&id=14a7291b&"
import script from "./AdviserSettings.vue?vue&type=script&lang=js&"
export * from "./AdviserSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports